import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { MessageContext } from "../context/message-context";

const useStyles = makeStyles({
    actionButton: {
        color: '#FFFFFF',
        backgroundColor: '#0C4C35',
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#63D764',
        },
        marginTop: 4,
        marginRight: 8,
        padding: '2px 10px 2px 10px'
    },
    cancelButton: {
        color: '#0C4C35',
        border: '1px solid #0C4C35',
        '&:hover': {
            color: '#63D764',
            border: '1px solid #63D764',
        },
        marginTop: 4,
        marginRight: 8,
        padding: '2px 10px 2px 10px'
    },
    loginField:{
      width: '100%',
    }

});

export default function ForgottenDialog(props) {
  
  const classes = useStyles();
  const {isForgotten, onClose} = props;
  const [state, dispatch] = useContext(MessageContext);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);

  const handleSubmit = (event) => {
    
      //setOpen(false);
      setSnackOpen(true);
      const abortController = new AbortController();
      const request = {   
        email:email,
      };

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/forgotten', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){

          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
  };

  const handleClose = () => {
    props.onClose(true);
    setOpen(false);
    setSnackOpen(false);

  }

//If the email address you entered matches one we have on file, we willsend you a 

  return (
      <div>
        <Dialog open={isForgotten} onClose={onClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Reset password</DialogTitle>
            <DialogContent>
              <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleClose}>
                  <Alert onClose={handleClose} severity="success">
                    If your email is present within our system a password reset email will be sent.
                  </Alert>
              </Snackbar>
              <DialogContentText fontSize={16}>
                  Please enter your email address below to reset your password. If you do not receive an email shortly, please contact the Support Team on 020 3002 7449.
              </DialogContentText>
              <TextField type="email" name="email" label="email" className={classes.loginField} variant="outlined" size="small" margin="dense" value={email} onChange={e => setEmail(e.target.value)} required />
            </DialogContent>
            <DialogActions>
                <Box p={1}>
                    <Button className={classes.cancelButton} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button className={classes.actionButton} onClick={handleSubmit}>
                        Reset
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    </div>
  );
}